<template>
    <div v-if="segment" class="c-view">
        <InternalHeader>
            <div slot="title" class="c-internal-header__title">
                <a @click="$router.push('/health-scores')">
                    <Icon
                        :custom="'icon icon-arrow-left-1'"
                        :size="18"
                        class="mr-1 mb-1"
                    ></Icon
                    >Health Scores
                </a>
                / {{ segment.name }}
            </div>
        </InternalHeader>
        <Row class="mt-5" :gutter="16">
            <Col span="6">
                <health-score-subnav :segment="segment"></health-score-subnav>
            </Col>
            <Col span="18">
                <health-score-status
                    v-bind:value.sync="segment.status_id"
                ></health-score-status>
                <Row :gutter="16" v-if="scoreComponents">
                    <Col span="24" v-if="scoreComponents.length > 0">
                        <h2 class="mt-5 font-weight-normal">
                            <health-score-component-create-button
                                @submit="handleAddComponent"
                                class="float-right"
                            ></health-score-component-create-button
                            >Components
                        </h2>
                        <health-score-component-list
                            class="mt-5"
                            :display-controls="true"
                            :segment-id="segmentId"
                            :score-components="scoreComponents"
                            @delete-component="handleDeleteComponent"
                            @clone-component="handleCloneComponent"
                        ></health-score-component-list>
                    </Col>
                    <Col :span="24" v-else>
                        <empty-state class="text-center mt-8">
                            <doctor-illustration
                                slot="illustration"
                                class="util-max-w250"
                            ></doctor-illustration>
                            <div slot="text">
                                You haven't added any score components yet.
                            </div>

                            <health-score-component-create-button
                                slot="actions"
                                @submit="handleAddComponent"
                                button-text="Add Your First Component"
                            ></health-score-component-create-button>
                        </empty-state>
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
</template>

<script>
import FilterGroup from "@/js/components/partials/filters/models/filter-group";

export default {
    props: {
        segmentId: Number,
        segmentsRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/segments.js"))();
            },
        },
    },
    data: function () {
        return {
            segment: null,
            scoreComponents: null,
            filterGroup: null,
        };
    },
    components: {
        InternalHeader: function () {
            return import("@/js/components/partials/header");
        },
        EmptyState: function () {
            return import("@/js/components/partials/empty-state");
        },
        DoctorIllustration: function () {
            return import(
                "@/js/components/partials/illustrations/surgeon-female-caucasian"
            );
        },
        HealthScoreCreateButton: function () {
            return import(
                "@/js/components/partials/health-score-create-button"
            );
        },
        EntityFilters: function () {
            return import("@/js/components/partials/filters");
        },
        HealthScoreSubnav: function () {
            return import("@/js/components/partials/health-score-subnav");
        },
        HealthScoreStatus: function () {
            return import("@/js/components/partials/health-score-status");
        },
        HealthScoreActiveCount: function () {
            return import("@/js/components/partials/health-score-active-count");
        },
        HealthScoreScoreAverage: function () {
            return import(
                "@/js/components/partials/health-score-score-average"
            );
        },
        HealthScoreComponentList: function () {
            return import(
                "@/js/components/partials/health-score-component-list"
            );
        },
        HealthScoreComponentCreateButton: function () {
            return import(
                "@/js/components/partials/health-score-component-create-button"
            );
        },
    },
    created() {
        this.load();
    },
    watch: {
        segmentId() {
            this.load();
        },
        segment: {
            handler() {
                if (this.segment) {
                    this.$root.$emit("page-title:update", this.segment.name);
                }
            },
            deep: true,
        },
    },
    methods: {
        initializeFilters() {
            var definition = JSON.parse(
                _.get(this.segment, "definition", "{}")
            );
            this.filterGroup = new FilterGroup(definition.filters);
        },
        clear() {
            this.segment = null;
            this.filterGroup = null;
        },
        async load() {
            this.clear();
            this.loadComponents();
            await this.loadSegment();
            this.initializeFilters();
        },
        async loadSegment() {
            const response = await this.segmentsRepository.show(this.segmentId);
            this.segment = response.data.data;
            this.$watch("segment", this.saveSegment, { deep: true });
        },
        async loadComponents() {
            let request = {
                params: {
                    q: ["parent_segment_id[eq]=" + this.segmentId],
                    sort_by: "score_component_weight:desc,name:asc",
                },
            };
            const response = await this.segmentsRepository.index(request);
            this.scoreComponents = response.data.data;
        },
        async saveSegment() {
            await this.segmentsRepository.update(this.segment.id, {
                status_id: this.segment.status_id,
            });
        },
        async handleDeleteComponent(componentId) {
            let index = this.scoreComponents.findIndex(
                (segment) => segment.id == componentId
            );
            this.scoreComponents.splice(index, 1);
            await this.segmentsRepository.remove(componentId);
        },
        async handleCloneComponent(componentId) {
            var item = _.find(this.scoreComponents, { id: componentId });
            let request = {};
            item.name = item.name + " [Copy]";
            let response = await this.segmentsRepository.store(item, request);
            this.$router.push(
                "/health-scores/" +
                    this.segmentId +
                    "/components/" +
                    response.data.data.id
            );
        },
        async handleAddComponent(data) {
            let request = {};
            let payload = {
                parent_segment_id: this.segmentId,
                name: data.name,
                score_component_weight: data.score,
                type_id: 4,
                entity_type_id: 1,
                is_shared: false,
                tag_enabled: false,
                definition: JSON.stringify({}),
            };
            let response = await this.segmentsRepository.store(
                payload,
                request
            );

            this.$router.push(
                "/health-scores/" +
                    this.segmentId +
                    "/components/" +
                    response.data.data.id
            );
        },
    },
};
</script>
